'use strict';

const Tabs = {
	/**
	* @description Cache dom and strings
	* @type {object}
	*/

	/** @description Initialize */
	init: function() {
		this.tabs();
	},
	/** @description */

	tabs() {
		const tabHeader = document.getElementById('tabHeader');
		const tabIndicator = document.getElementById('tabIndicator');
		const tabBody = document.getElementById('tabBody');
		const tabsPane = document.getElementsByClassName('js-tab-link');
		if (tabsPane) {
			for(let i = 0; i < tabsPane.length; i++) {
				tabsPane[i].addEventListener('click', function() {
					tabHeader.getElementsByClassName('active')[0].classList.remove('active');
					tabsPane[i].classList.add('active');
					tabBody.getElementsByClassName('active')[0].classList.remove('active');
					tabBody.getElementsByClassName('js-tab-inner')[i].classList.add('active');
					tabIndicator.style.left = `calc(calc(100% / 3) * ${i})`;
				});
			}
			if (tabsPane.length < 3) {
				for(let i = 0; i < tabsPane.length; i++) {
					tabsPane[i].addEventListener('click', function() {
						tabHeader.getElementsByClassName('active')[0].classList.remove('active');
						tabsPane[i].classList.add('active');
						tabBody.getElementsByClassName('active')[0].classList.remove('active');
						tabBody.getElementsByClassName('js-tab-inner')[i].classList.add('active');
						tabIndicator.style.left = `calc(calc(100% / 2) * ${i})`;
					});
					tabHeader.classList.add('two-tab');
					tabIndicator.classList.add('two-tab-indicator');
				}
			}
			if (tabsPane.length < 2) {
				for(let i = 0; i < tabsPane.length; i++) {
					tabsPane[i].addEventListener('click', function() {
						tabHeader.getElementsByClassName('active')[0].classList.remove('active');
						tabsPane[i].classList.add('active');
						tabBody.getElementsByClassName('active')[0].classList.remove('active');
						tabBody.getElementsByClassName('js-tab-inner')[i].classList.add('active');
						tabIndicator.style.left = `calc(calc(100% / 1) * ${i})`;
					});
					tabHeader.classList.add('one-tab');
					tabIndicator.classList.add('one-tab-indicator');
				}
			}
		}
	}
};

export default Tabs;